import { FiMic, FiChevronRight, FiTrash2 } from "react-icons/fi";

interface JournalEntryCardProps {
  title: string;
  preview: string;
  date: string;
  dateId?: string;
  weekNumber?: number;
  hasVoiceNote?: boolean;
  onClick?: () => void;
  onDelete?: () => void;
}

const JournalEntryCard = ({ title, preview, date, dateId, weekNumber, hasVoiceNote, onClick, onDelete }: JournalEntryCardProps) => {
  return (
    <div className="w-full glass-card p-4 text-left transition-all hover:card-shadow-hover active:scale-[0.98] group">
      <div className="flex items-start gap-3">
        <button
          onClick={onClick}
          className="flex-1 min-w-0 text-left border-0 bg-transparent p-0 cursor-pointer"
        >
          <div className="flex items-center gap-2 mb-1">
            <h4 className="font-dm-sans text-base font-semibold truncate m-0 text-brand-dark">{title}</h4>
          </div>
          <p className="text-xs text-muted-foreground line-clamp-2 leading-relaxed mb-2 m-0">{preview}</p>
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-[10px] text-muted-foreground font-medium">{dateId || date}</span>
            {weekNumber != null && weekNumber > 0 && (
              <span className="text-[10px] font-medium text-muted-foreground/70 border border-border px-1.5 py-px rounded-md">
                W{weekNumber}
              </span>
            )}
            {hasVoiceNote && (
              <span className="flex items-center gap-1 text-[10px] text-primary font-medium bg-primary/10 px-2 py-0.5 rounded-full">
                <FiMic size={12} />
                Voice
              </span>
            )}
          </div>
        </button>

        <div className="flex items-center gap-1 mt-1">
          {onDelete && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDelete();
              }}
              className="w-7 h-7 rounded-lg flex items-center justify-center text-muted-foreground/40 hover:text-red-500 hover:bg-red-50 transition-colors border-0 bg-transparent cursor-pointer"
              title="Delete"
            >
              <FiTrash2 size={13} />
            </button>
          )}
          <button
            onClick={onClick}
            className="w-7 h-7 rounded-lg flex items-center justify-center text-muted-foreground/30 group-hover:text-muted-foreground transition-colors border-0 bg-transparent cursor-pointer"
          >
            <FiChevronRight size={14} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default JournalEntryCard;
